import { useReducer, useEffect } from 'react';

import EmailSubjectAutocompleteInput from './form-inputs/EmailSubjectAutocompleteInput';

const initialState = (job_application_email_subject) => ({
  isInvalid: false,
  invalid: '',
  data: {
    job_application_email_subject,
  },
});

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE':
      return {
        ...state,
        ...action.payload,
      };
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
  }
};

export default function JobApplicationEmailSubjectInput(props) {
  const { name, email_subject_variables, job_application_email_subject } = props;

  const [state, dispatch] = useReducer(reducer, job_application_email_subject, initialState);

  const { isInvalid, invalid } = state;

  useEffect(() => {
    const hasEmptyBraces = state.data.job_application_email_subject.match(/{{\s*}}/g);

    if (hasEmptyBraces) {
      dispatch({ type: 'UPDATE', payload: { isInvalid: true, invalid: 'E-mail subject cannot contain empty curly braces {{}}' } });
      return;
    }

    dispatch({ type: 'UPDATE', payload: { isInvalid: false, invalid: '' } });
  }, [state.data.job_application_email_subject]);

  return (
    <div className="d-flex flex-column gap-1">
      <EmailSubjectAutocompleteInput
        name={name}
        value={state.data.job_application_email_subject}
        onChange={(value) =>
          dispatch({
            type: 'UPDATE_DATA',
            payload: { job_application_email_subject: value },
          })
        }
        options={email_subject_variables}
      />
      <span className="text-muted fs-5">Add in modifiers by typing '{'{{'}'</span>
      {isInvalid && <label className="text-danger fs-5">{invalid}</label>}
    </div>
  );
}
